"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@emotion/react");
var _styles = require("./styles");
var _Header = _interopRequireDefault(require("../../core/Header"));
var _Button = _interopRequireDefault(require("../../core/Button"));
var _useIsMobile = require("../../hooks/useIsMobile");
var _List = _interopRequireDefault(require("../../core/List"));
var _IconChevronDown = _interopRequireDefault(require("../../icons/General/IconChevronDown"));
var _SubmenuLightThemeBg = _interopRequireDefault(require("./SubmenuLightThemeBg"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const Submenu = ({
  lightTheme,
  header,
  children,
  illustration,
  customHeader,
  onOpenChange
}) => {
  const ref = /*#__PURE__*/(0, _react.createRef)();
  const theme = (0, _react2.useTheme)();
  const isMobile = (0, _useIsMobile.useIsMobile)();
  const hasChildren = children && children.length > 0;
  const [open, toggleOpen] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const handleClickOutside = e => {
      const node = ref.current;
      if (node && node.contains(e.target)) {
        return;
      }
      handleOpen(false);
    };
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      handleOpen(false);
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open, ref]);
  const handleClick = () => {
    handleOpen(false);
  };
  const handleOpen = open => {
    toggleOpen(open);
    onOpenChange?.(open);
  };
  return (0, _jsxRuntime.jsxs)("div", {
    ref: ref,
    css: theme => [_styles.styles.default, lightTheme ? _styles.styles.lightTheme(theme) : _styles.styles.darkTheme(theme, hasChildren ? '1em' : '2em')],
    children: [(0, _jsxRuntime.jsxs)(_styles.HeaderWrapper, {
      children: [customHeader && customHeader, header && (0, _jsxRuntime.jsx)(_Header.default, {
        color: lightTheme ? theme.secondaryDarkText : theme.submenuTextColorActive,
        level: 1,
        children: header
      })]
    }), children && children.length > 0 && (0, _jsxRuntime.jsx)(_react.Fragment, {
      children: !isMobile ? (0, _jsxRuntime.jsx)(_styles.Wrapper, {
        className: "submenuwrapper",
        children: (0, _jsxRuntime.jsx)(_styles.MenuItemList, {
          role: "menu",
          children: children.map((child, key) => {
            if (!child) {
              return null;
            }
            return /*#__PURE__*/_react.default.cloneElement(child, {
              key
            });
          })
        })
      }) : (0, _jsxRuntime.jsxs)(_styles.DropdownWrapper, {
        className: "submenuwrapper",
        children: [(0, _jsxRuntime.jsx)(_Button.default, {
          nostyle: true,
          css: (0, _styles.ButtonStyle)(theme, !lightTheme),
          onClick: () => handleOpen(!open),
          afterIcon: (0, _jsxRuntime.jsx)(_IconChevronDown.default, {
            flipVertical: open,
            size: 14
          }),
          children: children.filter(x => x).map((child, key) => {
            if (!child) {
              return null;
            }
            return /*#__PURE__*/_react.default.cloneElement(child, {
              showActiveitemLabel: true,
              key
            });
          })
        }), (0, _jsxRuntime.jsx)(_styles.OptionsWrapper, {
          lightTheme: lightTheme,
          children: open && (0, _jsxRuntime.jsx)(_List.default, {
            selectList: true,
            role: "menu",
            darkTheme: !lightTheme,
            children: children.filter(x => x).map((child, key) => {
              if (!child) {
                return null;
              }
              return /*#__PURE__*/_react.default.cloneElement(child, {
                onChange: handleClick,
                key
              });
            })
          })
        })]
      })
    }), (lightTheme || illustration) && (0, _jsxRuntime.jsxs)(_styles.IllustrationOverlay, {
      children: [lightTheme && (0, _jsxRuntime.jsx)(_SubmenuLightThemeBg.default, {
        bgColor: theme.customIllustrationColor
      }), illustration && (0, _jsxRuntime.jsx)(_styles.IllustrationWrapper, {
        style: {
          zIndex: 0
        },
        children: illustration
      })]
    })]
  });
};
var _default = exports.default = Submenu;